'use strict';
var isCallable = require('../internals/is-callable');

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/is-object.js
// module id = RR8F
// module chunks = 0